export default "__VITE_ASSET__MRY9KwgB__"